<script>
    export let title; //标题
    export let clickable = true; //点击效果
    export let disabled = false;
    let clsPrefix = "sui-cell";
    let active = false;
    function start() {
        if (!clickable) return;
        active = true;
    }
    function end() {
        if (!clickable) return;
        active = false;
    }
</script>

<div
    class={`${clsPrefix} ${$$props.class || ""}`}
    class:clickable
    class:disabled
    class:active
    on:click
    on:touchstart={start}
    on:touchend={end}
    on:touchcancel={end}
>
    <div class={`${clsPrefix}-inner`}>
        <div class={`${clsPrefix}-icon`} >
            <slot name="icon" />
        </div>
        <div class={`${clsPrefix}-con`}>
            {#if title}
                <b class={`${clsPrefix}-con-title`}>{title}</b>
            {/if}
            <div class={`${clsPrefix}-desc`}>
                <slot />
            </div>
        </div>
        {#if $$slots.extra}
            <div class={`${clsPrefix}-extra`}>
                <slot name="extra" />
            </div>
        {/if}
        {#if clickable}
            <svg
                class={`${clsPrefix}-arrow`}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.92462 4.57538L16.3492 12L8.92462 19.4246"
                    stroke="#000A1F"
                    stroke-opacity="0.3"
                    stroke-width="1.875"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        {/if}
    </div>
</div>

<style lang="less">
    @import "./cell.less";
</style>
